/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, title: NonNullable<unknown> }} Builds_Meta_DescriptionInputs */

const id_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.version} untuk ${i?.title} dari Epic Games Store.`)
};

const ms_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Binaan ${i?.version} untuk ${i?.title} dari Epic Games Store.`)
};

const da_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build til ${i?.title} fra Epic Games Store.`)
};

const de_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build für ${i?.title} aus dem Epic Games Store.`)
};

const en_us2_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build for ${i?.title} from the Epic Games Store.`)
};

const es_es2_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilación ${i?.version} para ${i?.title} de la Epic Games Store.`)
};

const es_mx2_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilación ${i?.version} para ${i?.title} de la Epic Games Store.`)
};

const fil_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.version} para sa ${i?.title} mula sa Epic Games Store.`)
};

const fr_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilation ${i?.version} pour ${i?.title} de l'Epic Games Store.`)
};

const it_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.version} per ${i?.title} dall'Epic Games Store.`)
};

const hu_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build a ${i?.title} játékhoz az Epic Games Store-ból.`)
};

const nl_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build voor ${i?.title} van de Epic Games Store.`)
};

const no_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} Build for ${i?.title} fra Epic Games Store.`)
};

const pl_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kompilacja ${i?.version} dla ${i?.title} z Epic Games Store.`)
};

const pt_br2_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build ${i?.version} para ${i?.title} da Epic Games Store.`)
};

const pt_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilação ${i?.version} para ${i?.title} da Epic Games Store.`)
};

const ro_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilare ${i?.version} pentru ${i?.title} din Epic Games Store.`)
};

const fi_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koontiversio ${i?.version} pelille ${i?.title} Epic Games Storesta.`)
};

const sv_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bygge ${i?.version} för ${i?.title} från Epic Games Store.`)
};

const vi_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bản dựng ${i?.version} cho ${i?.title} từ Epic Games Store.`)
};

const tr_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store'dan ${i?.title} için ${i?.version} Yapısı.`)
};

const cs_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sestavení ${i?.version} pro ${i?.title} z Epic Games Store.`)
};

const bg_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Компилация ${i?.version} за ${i?.title} от Epic Games Store.`)
};

const ru_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сборка ${i?.version} для ${i?.title} из Epic Games Store.`)
};

const uk_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Збірка ${i?.version} для ${i?.title} з Epic Games Store.`)
};

const ar_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`البنية ${i?.version} لـ ${i?.title} من Epic Games Store.`)
};

const hi_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store से ${i?.title} के लिए बिल्ड ${i?.version}।`)
};

const th_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บิลด์ ${i?.version} สำหรับ ${i?.title} จาก Epic Games Store`)
};

const ja_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store の ${i?.title} 向けビルド ${i?.version}。`)
};

const zh_cn2_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 的 ${i?.version} 构建版本，来自Epic游戏商城。`)
};

const zh_hant1_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 的 ${i?.version} 建置版本，來自Epic遊戲商城。`)
};

const ko_builds_meta_description = /** @type {(inputs: Builds_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 ${i?.title}용 ${i?.version} 빌드입니다.`)
};

/**
* | output |
* | --- |
* | "{version} Build for {title} from the Epic Games Store." |
*
* @param {Builds_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_meta_description = /** @type {((inputs: Builds_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_meta_description(inputs)
	if (locale === "ms") return ms_builds_meta_description(inputs)
	if (locale === "da") return da_builds_meta_description(inputs)
	if (locale === "de") return de_builds_meta_description(inputs)
	if (locale === "en-US") return en_us2_builds_meta_description(inputs)
	if (locale === "es-ES") return es_es2_builds_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_builds_meta_description(inputs)
	if (locale === "fil") return fil_builds_meta_description(inputs)
	if (locale === "fr") return fr_builds_meta_description(inputs)
	if (locale === "it") return it_builds_meta_description(inputs)
	if (locale === "hu") return hu_builds_meta_description(inputs)
	if (locale === "nl") return nl_builds_meta_description(inputs)
	if (locale === "no") return no_builds_meta_description(inputs)
	if (locale === "pl") return pl_builds_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_builds_meta_description(inputs)
	if (locale === "pt") return pt_builds_meta_description(inputs)
	if (locale === "ro") return ro_builds_meta_description(inputs)
	if (locale === "fi") return fi_builds_meta_description(inputs)
	if (locale === "sv") return sv_builds_meta_description(inputs)
	if (locale === "vi") return vi_builds_meta_description(inputs)
	if (locale === "tr") return tr_builds_meta_description(inputs)
	if (locale === "cs") return cs_builds_meta_description(inputs)
	if (locale === "bg") return bg_builds_meta_description(inputs)
	if (locale === "ru") return ru_builds_meta_description(inputs)
	if (locale === "uk") return uk_builds_meta_description(inputs)
	if (locale === "ar") return ar_builds_meta_description(inputs)
	if (locale === "hi") return hi_builds_meta_description(inputs)
	if (locale === "th") return th_builds_meta_description(inputs)
	if (locale === "ja") return ja_builds_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_meta_description(inputs)
	return ko_builds_meta_description(inputs)
});
export { builds_meta_description as "builds.meta.description" }